import { render } from "./project_video_bg_image.vue?vue&type=template&id=179f4d4f"
import script from "./project_video_bg_image.vue?vue&type=script&lang=js"
export * from "./project_video_bg_image.vue?vue&type=script&lang=js"

import "./project_video_bg_image.vue?vue&type=style&index=0&id=179f4d4f&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__